// Dependencies
require("webstrap/scaffolding");

// Styles
require("./responsive-utilities.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/webstrap/responsive-utilities/index.js
 ** module id = 26
 ** module chunks = 0 1
 **/